import React, { useState } from 'react';
import { Button } from './ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Calendar, MapPin, Package, Truck } from 'lucide-react';

const Hero = ({ onBookNow }) => {
  const [explainerOpen, setExplainerOpen] = useState(false);

  return (
    <>
      <section className="relative min-h-screen flex items-center justify-center pt-20">
        {/* Background Image with Overlay */}
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: `url('https://images.pexels.com/photos/18805260/pexels-photo-18805260.jpeg?w=1920&h=1080&fit=crop')`,
          }}
        >
          <div className="absolute inset-0 bg-gray-900/70"></div>
        </div>

        {/* Content */}
        <div className="relative z-10 text-center px-4 max-w-4xl mx-auto">
          <p className="text-lg md:text-xl text-gray-300 mb-4 italic">
            Commercial and <span className="text-[#22C55E] underline">Residential</span> Dump Trailer Rental
          </p>
          
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-8 leading-tight">
            The Dump Trailer<br />Alternative
          </h1>
          
          <p className="text-gray-300 text-lg mb-10 max-w-2xl mx-auto">
            Serving Central Wisconsin with convenient, damage-free dump trailer solutions on demand
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button 
              size="lg"
              onClick={onBookNow}
              className="bg-[#22C55E] hover:bg-[#16A34A] text-white px-10 py-6 text-lg font-semibold rounded-md transition-all duration-300 hover:scale-105 shadow-lg"
            >
              Book Now
            </Button>
            
            <Button 
              size="lg"
              variant="outline"
              className="bg-white hover:bg-gray-100 text-[#22C55E] border-2 border-white px-10 py-6 text-lg font-semibold rounded-md transition-all duration-300"
              onClick={() => setExplainerOpen(true)}
            >
              Dump Trailer Dude® Explained
            </Button>
          </div>
        </div>

        {/* Scroll Indicator */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
          <div className="w-8 h-12 border-2 border-white/50 rounded-full flex items-start justify-center p-2">
            <div className="w-1.5 h-3 bg-white/70 rounded-full animate-pulse"></div>
          </div>
        </div>
      </section>

      {/* Explainer Modal */}
      <Dialog open={explainerOpen} onOpenChange={setExplainerOpen}>
        <DialogContent className="max-w-3xl">
          <DialogHeader>
            <DialogTitle className="text-2xl font-bold text-center mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_cenwi-dumpsters/artifacts/as0yrnig_ChatGPT%20Image%20Jan%2023%2C%202026%2C%2002_46_35%20PM.png" 
                alt="Dump Trailer Dude"
                className="h-16 w-auto mx-auto mb-2"
              />
              <span className="text-gray-700">Explained</span>
            </DialogTitle>
          </DialogHeader>
          
          <div className="space-y-6 py-4">
            <p className="text-gray-600 text-center">
              Dump Trailer Dude is Central Wisconsin's premier dump trailer rental service. Our innovative wheel-based dump trailers offer a smarter, more convenient alternative to traditional roll-off dumpsters.
            </p>
            
            <div className="grid grid-cols-2 gap-4">
              <div className="flex items-start space-x-3 p-4 bg-gray-50 rounded-lg">
                <Calendar className="w-8 h-8 text-[#22C55E] flex-shrink-0" />
                <div>
                  <h4 className="font-semibold text-gray-800">On-Demand Scheduling</h4>
                  <p className="text-sm text-gray-600">Book your dump trailer in minutes</p>
                </div>
              </div>
              <div className="flex items-start space-x-3 p-4 bg-gray-50 rounded-lg">
                <MapPin className="w-8 h-8 text-[#22C55E] flex-shrink-0" />
                <div>
                  <h4 className="font-semibold text-gray-800">Precise Delivery</h4>
                  <p className="text-sm text-gray-600">We place it where you need it</p>
                </div>
              </div>
              <div className="flex items-start space-x-3 p-4 bg-gray-50 rounded-lg">
                <Package className="w-8 h-8 text-[#22C55E] flex-shrink-0" />
                <div>
                  <h4 className="font-semibold text-gray-800">14 Cubic Yard Trailers</h4>
                  <p className="text-sm text-gray-600">Plenty of room for any project</p>
                </div>
              </div>
              <div className="flex items-start space-x-3 p-4 bg-gray-50 rounded-lg">
                <Truck className="w-8 h-8 text-[#22C55E] flex-shrink-0" />
                <div>
                  <h4 className="font-semibold text-gray-800">Hassle-Free Pickup</h4>
                  <p className="text-sm text-gray-600">We handle everything</p>
                </div>
              </div>
            </div>

            <div className="text-center pt-4">
              <Button 
                className="bg-[#22C55E] hover:bg-[#16A34A] text-white px-8 py-3"
                onClick={() => {
                  setExplainerOpen(false);
                  onBookNow();
                }}
              >
                Get Your Dump Trailer Today
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default Hero;
